import * as React from 'react';
import { Auth0MockContainer } from '../../organisms/Auth0MockContainer';
import { Trans } from '@lingui/react';
import { UsernameForm } from '../../organisms/UsernameForm';
import { FormattedError } from '../../atoms/FormattedError';
import { extractError } from '../../../utils/extractError';
import { extractData } from '../../../utils/extractData';
import axios from 'axios';
import { useState } from 'react';

export interface IAxiRegistrationProps {}

const AxiRegistration: React.FC<IAxiRegistrationProps> = () => {
  const [error, setError] = useState<JSX.Element | null>(null);
  const onSubmit = async (data?: { username?: string }) => {
    try {
      await axios
        .post(`/api/axi/request-verify-email-code`, {
          data,
        })
        .then(extractData)
        .then((data) => (window.location.href = data.message))
        .catch(extractError);
    } catch (e: any) {
      setError(<FormattedError type={e.message} />);
      setTimeout(() => {
        setError(null);
      }, 5000);
    }
  };
  return (
    <Auth0MockContainer
      description={<Trans id="Choose credentials for your new account." />}
      title={<Trans id="Welcome" />}
      uiTheme={'axi'}
    >
      <UsernameForm
        alternatePlaceholder={<Trans id="Email address*" />}
        onSubmit={onSubmit}
        error={error}
        isExocadUser={false}
        buttonText={<Trans id="Continue" />}
        forceEmailInput={true}
        blockInvalidEmailDomains={true}
      />
    </Auth0MockContainer>
  );
};

export default AxiRegistration;
